export default __webpack_public_path__ + "static/media/hht2_ep01_book_wp_02.78767d8e.jpg";